import { ref, computed } from 'vue'
import axios from 'axios'

const cdnUrl = import.meta.env.VITE_WHITELABEL_AZURE_ENDPOINT

let subdomain = window.location.hostname.split('.')[0]
subdomain = import.meta.env.VITE_WHITELABEL_SUBDOMAIN || subdomain

const version = ref(0)
const cachedSettings = ref({})
const defaultLogoUrl = computed(() => `${cdnUrl}/${subdomain}/default-logo.v${version.value}.png`)
const signupLogoUrl = computed(() => `${cdnUrl}/${subdomain}/signup-logo.v${version.value}.png`)

export async function initWhitelabel() {
  const { data: currentVersion } = await axios.get(`${cdnUrl}/${subdomain}/version.txt`)
  version.value = currentVersion

  // Fetch config
  const [{ data: configData }, { data: dictionaryData }] = await Promise.all([
    axios.get(`${cdnUrl}/${subdomain}/config.v${currentVersion}.json`),
    axios.get(`${cdnUrl}/${subdomain}/dictionary.v${currentVersion}.json`)
  ])

  // Cache whitelabel config
  cachedSettings.value = configData

  return { dictionaryData, configData, styleSheetUrl: `${cdnUrl}/${subdomain}/style.v${currentVersion}.css` }
}

export default function (domain = 'global') {
  return {
    defaultLogoUrl,
    signupLogoUrl,
    config: computed(() => cachedSettings.value[domain] || {})
  }
}
